<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('checklist.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <!-- process -->
        <div v-for="p in process" :key="p.Id">
          <!-- {{p.permission}} -->
          <div v-if="getPermission(p.permission)">
            <!-- <sidebar-item
                :link="{
                  name: `${p.displayName}`,
                  path: `/workflow/kanban/${p.displayName}/${p.id}`,
                  icon: 'tim-icons icon-chart-pie-36',
                }"
              ></sidebar-item> -->
            <sidebar-item
              ref="sidebarItemForms"
              :link="{
                name: `${p.displayName}`,
                icon: 'tim-icons icon-chart-pie-36'
              }"
            >
              <sidebar-item
                :link="{
                  name: `Kanban`,
                  path: `/workflow/kanban/${p.displayName}/${p.id}`
                }"
              ></sidebar-item>
              <!-- 173: homologação  |  produção: 13-->
              <sidebar-item
                v-if="
                  ($store.getters.companyId == 1 && p.id == 173) ||
                    ($store.getters.companyId == 398 && p.id == 13)
                "
                :link="{
                  name: `Preenchidos`,
                  path: `/workflow/filled/shlog/${p.displayName}/${p.id}`
                }"
              ></sidebar-item>
              <sidebar-item
                v-else
                :link="{
                  name: `Preenchidos`,
                  path: `/workflow/filled/${p.displayName}/${p.id}`
                }"
              ></sidebar-item>
              <sidebar-item
                v-if="$store.getters.companyId == 398 && p.id == 13"
                :link="{
                  name: `Status das viagens`,
                  path: `/shlog/tripStatus/`,
                  icon: 'tim-icons icon-chart-pie-36'
                }"
              ></sidebar-item>
              <sidebar-item
                v-if="$store.getters.companyId == 398 && p.id == 13"
                :link="{
                  name: `Status da frota`,
                  path: `/shlog/fleet/status/list/`,
                  icon: 'tim-icons icon-chart-pie-36'
                }"
              ></sidebar-item>
              <sidebar-item
                v-if="$store.getters.companyId == 398 && p.id == 13"
                :link="{
                  name: `Monitoramento logístico`,
                  path: `/shlog/monitoramentoLogistico/`,
                  icon: 'tim-icons icon-chart-pie-36'
                }"
              ></sidebar-item>
            </sidebar-item>
          </div>
        </div>

        <sidebar-item
          v-if="
            $store.getters.companyId == 1 || $store.getters.companyId == 398
          "
          :link="{
            name: `Frete Rápido`,
            icon: 'tim-icons icon-chart-pie-36'
          }"
        >
          <sidebar-item
            :link="{
              name: `NF-e Solicitações de Coleta`,
              path: `/shlog/freteRapido/solicitacaoColeta/nfe/`
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('workflow.process'),
            icon: 'tim-icons icon-notes'
          }"
        >
          <sidebar-item
            :link="{
              name: $t('workflow.create'),
              path: '/workflow/Create'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('workflow.processList'),
              path: '/workflow/processList'
            }"
          ></sidebar-item>
          <!-- <sidebar-item
            :link="{
              name: $t('workflow.processField.filled'),
              path: '/workflow/process/filled/list',
            }"
          ></sidebar-item> -->
        </sidebar-item>

        <!-- {{ "Veiculos: " + this.$store.getters.accessVehicles }} -->
        <sidebar-item
          v-if="isAccessVehicles"
          ref="sidebarItemPendencies"
          :link="{
            name: 'Equipamentos',
            icon: 'tim-icons icon-delivery-fast'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Equipamento',
              path: '/workflow/vehicleRegistration/list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Marca de Equipamento',
              path: '/workflow/brandVehicle/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Modelo de Equipamento',
              path: '/workflow/vehicleModel/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Tipo do Equipamento',
              path: '/workflow/vehicleType/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Ativar/Desativar',
              path: '/workflow/vehicleAvailableReason/list'
            }"
          />
        </sidebar-item>

        <!-- Abastecimentos -->
        <!-- <sidebar-item
          ref="sidebarFuelSupply"
          :link="{
            name: $t('fuelSupply.sidebarMain'),
            icon: 'tim-icons icon-alert-circle-exc',
          }"
        >
          <sidebar-item
            :link="{
              name: 'BI Abastecimento',
              path: '/workflow/fuelSupplyDashboard',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('fuelConsumptionTarget.sidebar'),
              path: '/workflow/fuelConsumptionTarget/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('fuelStock.sidebar'),
              path: '/workflow/fuelStock/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('gasStation.sidebar'),
              path: '/workflow/gasStation/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
        </sidebar-item> -->

        <!-- {{ "Plano de viagem: " + this.$store.getters.accessTripPlan }} -->

        <sidebar-item
          v-if="isAccessTripPlan"
          :link="{
            name: $t('tripPlan.plural'),
            path: '/workflow/pathList',
            icon: 'tim-icons icon-square-pin'
          }"
        />

        <sidebar-item
          v-if="isAccessTripPlan"
          :link="{
            name: $t('tripPlan.waypoints'),
            path: '/workflow/waypointList',
            icon: 'tim-icons icon-pin'
          }"
        />
        <sidebar-item
          v-if="isUserViewer"
          :link="{
            name: $t('sidebar.usuarios'),
            path: '/workflow/user/list',
            icon: 'tim-icons icon-single-02'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isProfileViewer"
          :link="{
            name: $t('system.profile.sidebar'),
            path: '/workflow/profile/all',
            icon: 'tim-icons icon-single-02'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: $t('sidebar.sector'),
            path: '/workflow/sector/all',
            icon: 'tim-icons icon-vector'
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isMasterAdmin"
          :link="{
            name: $t('system.module.sidebar'),
            path: '/workflow/module/all',
            icon: 'tim-icons icon-components'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            $store.getters.isAdminRms == true ||
              $store.getters.companyId == 1 ||
              $store.getters.companyId == 177
          "
          :link="{
            name: $t('sidebar.empresas'),
            path: '/workflow/company/all',
            icon: 'tim-icons icon-bank'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="$store.getters.isAdminRms == true || isCompanyViewer == true"
          :link="{
            name: $t('sidebar.costCenterTitle'),
            path: '/workflow/costCenter/list',
            icon: 'tim-icons icon-money-coins'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="$store.getters.isAdminRms == true"
          :link="{
            name: $t('system.systemIntegration.sidebar'),
            path: '/workflow/systemIntegration/all',
            icon: 'tim-icons icon-single-02'
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="trackingShippingCompany"></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <!-- <div> {{$store.getters}} </div> -->
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
//import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}
import DashboardNavbar from "@/pages/Layout/DashboardNavbar.vue";
import ContentFooter from "src/pages/Layout/SidebarFixedToggleButton.vue";
import SidebarFixedToggleButton from "src/pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  name: "TrackingShippingCompanyLayout",
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
      isMasterAdmin: false,
      process: []
    };
  },
  created() {
    this.getUserMaster();
    this.getAllProcess();
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    isUserViewer() {
      return this.$store.getters.hasAccessUser;
    },
    isProfileViewer() {
      return this.$store.getters.hasAccessProfile;
    },
    isAccessTripPlan() {
      return this.$store.getters.accessTripPlan;
    },
    isCompanyViewer() {
      return this.$store.getters.hasAccessCompany;
    },
    isAccessVehicles() {
      return this.$store.getters.accessVehicles;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then(response => {
          this.isMasterAdmin = response.data;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getAllProcess() {
      this.$apiWorkflow.get("/process/all/").then(response => {
        this.process = response.data;
      });
    },
    getPermission(p) {
      if (p.administrador) return true;
      if (p.gestor) return true;
      if (p.advancedOperator) return true;
      if (p.simpleOperator) return true;
      return false;
    }
  },
  mounted() {
    // this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemSchedules) {
      if (this.$refs.sidebarItemSchedules.collapsed) {
        this.$refs.sidebarItemSchedules.collapseMenu();
      }
    }
  },
  watch: {}
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
